export type Dialog = {
  title: string
  text: string
  acceptText?: string
  acceptButtonColor?: string
  acceptCallback?: () => Promise<void> | void
  cancelText?: string
  cancelButtonColor?: string
  cancelCallback?: () => Promise<void> | void
  canCloseOutsideClick?: boolean
}

export default defineNuxtPlugin(() => {
  const dialogInfo = ref<Dialog | undefined>(undefined)
  const open = ref<boolean>(false)

  const router = useRouter()

  const openDialog = (dialog: Dialog) => {
    // 既に開いている場合は何もしない
    // これはconfirmでダイアログが開かれているとき
    // PromiseのResolveが呼ばれないパターンがあるため
    if (open.value) return
    dialogInfo.value = dialog
    open.value = true
  }

  const closeDialog = () => {
    open.value = false
  }

  const confirm = (
    text: string,
    title: string = '確認',
    acceptText: string = 'OK',
    cancelText: string = 'キャンセル',
    acceptButtonColor: string = 'primary',
    cancelButtonColor: string = 'default',
  ): Promise<boolean> =>
    new Promise<boolean>((resolve) => {
      openDialog({
        title,
        text,
        acceptText,
        acceptButtonColor,
        cancelText,
        cancelButtonColor,
        acceptCallback: () => {
          closeDialog()
          resolve(true)
        },
        cancelCallback: () => {
          closeDialog()
          resolve(false)
        },
        canCloseOutsideClick: false,
      })
    })

  // 別のページに移ったときはダイアログを閉じる
  router.afterEach(() => {
    closeDialog()
  })

  return {
    provide: {
      dialog: {
        open: readonly(open),
        dialog: readonly(dialogInfo),
        openDialog,
        closeDialog,
        confirm,
      },
    },
  }
})
